import { gql } from "@apollo/client";

export const UPSERT_USER_VETCOIN_BALANCE = gql`
  mutation upsertUserVetcoinBalance($user_id: uuid!, $balance: Int!) {
    insert_user_vetcoin_balance(
      objects: [{ user_id: $user_id, balance: $balance }]
      on_conflict: {
        constraint: user_vetcoin_balance_user_id_key
        update_columns: [balance, updated_at]
      }
    ) {
      affected_rows
      returning {
        user_vetcoin_balance_id
        user_id
        balance
        updated_at
      }
    }
  }
`;

export const ADD_VETCOIN_TRANSACTION = gql`
  mutation addVetcoinTransaction(
    $user_id: uuid!
    $action_type: String!
    $direction: String!
    $amount: Int!
    $source_feedback_id: uuid
    $source_post_id: uuid
    $store_item_id: uuid
    $metadata: jsonb
  ) {
    insert_vetcoin_transaction(
      objects: [
        {
          user_id: $user_id
          action_type: $action_type
          direction: $direction
          amount: $amount
          source_feedback_id: $source_feedback_id
          source_post_id: $source_post_id
          store_item_id: $store_item_id
          metadata: $metadata
        }
      ]
      on_conflict: {
        constraint: vetcoin_transaction_user_id_action_type_source_feedback_id_key
        update_columns: []
      }
    ) {
      affected_rows
      returning {
        vetcoin_transaction_id
        user_id
        amount
        direction
        action_type
        source_feedback_id
        source_post_id
      }
    }
  }
`;

export const ADD_VETCOIN_TRANSACTION_FOR_POST = gql`
  mutation addVetcoinTransactionForPost(
    $user_id: uuid!
    $action_type: String!
    $direction: String!
    $amount: Int!
    $source_post_id: uuid!
    $metadata: jsonb
  ) {
    insert_vetcoin_transaction(
      objects: [
        {
          user_id: $user_id
          action_type: $action_type
          direction: $direction
          amount: $amount
          source_post_id: $source_post_id
          metadata: $metadata
        }
      ]
      on_conflict: {
        constraint: vetcoin_transaction_user_id_action_type_source_post_id_key
        update_columns: []
      }
    ) {
      affected_rows
      returning {
        vetcoin_transaction_id
        user_id
        amount
        direction
        action_type
        source_post_id
      }
    }
  }
`;

export const BUY_STORE_ITEM = gql`
  mutation buyStoreItem($user_id: uuid!, $store_item_id: uuid!) {
    insert_user_store_item(
      objects: [{ user_id: $user_id, store_item_id: $store_item_id }]
      on_conflict: {
        constraint: user_store_item_user_id_store_item_id_key
        update_columns: []
      }
    ) {
      affected_rows
      returning {
        user_store_item_id
        user_id
        store_item_id
      }
    }
  }
`;

export const EQUIP_STORE_ITEM = gql`
  mutation equipStoreItem(
    $user_id: uuid!
    $store_item_id: uuid!
    $item_type: String!
  ) {
    insert_user_equipped_item(
      objects: [
        {
          user_id: $user_id
          store_item_id: $store_item_id
          item_type: $item_type
        }
      ]
      on_conflict: {
        constraint: user_equipped_item_user_id_item_type_key
        update_columns: [store_item_id, updated_at]
      }
    ) {
      affected_rows
      returning {
        user_equipped_item_id
        user_id
        item_type
        store_item_id
      }
    }
  }
`;
